module.exports = __webpack_public_path__ + "img/9788954427074.cc26ecd6.jpg";